import { createSlice } from '@reduxjs/toolkit';

export const initialState: any = {
  isOpen: false,
};

const LoaderSlice = createSlice({
  name: 'Loader',
  initialState,
  reducers: {
    isVisible(state, action) {
      state.isOpen = action.payload;
    },
  },
});

export const { isVisible } = LoaderSlice.actions;

export default LoaderSlice.reducer;
